export const twoFactorAuthenticationMethodConstants = {
    NONE:'None',
    SMS:'SMS',
    EMAIL:'Email',
    AUTHENTICATOR: 'Authenticator',
    BYPASS: 'Bypass',
}